import { MutationTree } from 'vuex'
import { TEnergyConsumptionTable, TEnergyGenerationTable, TMediaTablesState, TWaterConsumptionTable } from './types'

export default {
  SET_LOADING: (state: TMediaTablesState, loading: boolean) => (state.loading = loading),
  SET_ENERGY_CONSUMPTION_TABLE_DATA: (state: TMediaTablesState, energy_consumption_table_data: TEnergyConsumptionTable) => (state.energy_consumption = energy_consumption_table_data),
  SET_ENERGY_GENERATION_TABLE_DATA: (state: TMediaTablesState, energy_generation_table_data: TEnergyGenerationTable) => (state.energy_generation = energy_generation_table_data),
  SET_WATER_CONSUMPTION_TABLE_DATA: (state: TMediaTablesState, water_consumption_table_data: TWaterConsumptionTable) => (state.water_consumption = water_consumption_table_data)
} as MutationTree<TMediaTablesState>
